import styled, { css } from 'styled-components';

import { mediaDesktop } from 'utils/styles/responsive';
import { layout } from 'utils/styles/theme';

const { max } = layout.columns;

export const ArticleHeroWrapper = styled.div`
  position: relative;
  grid-column: 1 / -1;

  display: grid;
  grid-template-columns: repeat(${max}, 1fr);
`;

export const Hero = styled.img`
  margin-bottom: 32px;
  width: 100%;
  min-width: 100%;
  aspect-ratio: 16/9;
  object-position: top;
  object-fit: cover;

  grid-column: 1 / -1;

  ${mediaDesktop(css`
    margin-bottom: 72px;
  `)}
`;
